import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { TokenService } from '../services/token.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private tokenService: TokenService, private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.tokenService.userId$.pipe(
      take(1),
      map(userId => {
        const tokenInfo = this.tokenService.getTokenInfo();

        if (!tokenInfo || !tokenInfo.accessToken || !userId) {
          this.authService.logout();
          return this.router.createUrlTree(['/auth/login']);
        }

        const requiredPermissions = route.data['Permissions'] as string[];
        if (requiredPermissions && !this.hasPermissions(requiredPermissions, this.tokenService.getUserPermissionsFromToken())) {
          return this.router.createUrlTree(['/unauthorized']);
        }

        return true;
      })
    );
  }

  hasPermissions(required: string[], userPerms: string[]): boolean {
    return required.some(p => userPerms.includes(p));
  }
}
